
<template>
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/forgot-password.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Recupere su contraseña</h4>
                                    <p> Ingrese su dirección de correo electrónico.</p>
                                </div>
                                <vs-input 
                                    v-validate="'required|email'"
                                    data-vv-validate-on="blur"
                                    name="email"
                                    type="email"
                                    label-placeholder="Email"
                                    placeholder="Email*"
                                    v-model="email"
                                    class="w-full  mb-8" />
                                <span class="text-danger text-sm">{{ errors.first('confirm_contrasenia') }}</span>

                                <vs-button type="border" to="/account/login" class="px-4 w-full md:w-auto">Volver al Login</vs-button>
                                <vs-button class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0" @click="recuperarEmail() " :disabled="!validateForm">Recuperar Contraseña</vs-button>
                            </div>
                        </div>
                    </div>
                </div>
                <vs-popup class="holamundo" title="Mapgrafi informa" :active.sync="popupMensaje">
                    <p>{{ mensaje }}
                        <br>
                    </p>
                    <div class="flex flex-wrap justify-center mb-3">
                        <vs-button  color="primary"  @click="(popupMensaje = !popupMensaje)">Aceptar</vs-button>
                    </div>
                </vs-popup>
            </vx-card>
</template>

<script>
export default {
    data() {
        return {
            email: '',
            popupMensaje : false,
			mensaje : '',
        }
    },
    methods:{
        validatorOnline(){
            if(this.$store.state.AppActiveUser.status)
            this.$router.push('/');
        },
        recuperarEmail(){
            if (!this.validateForm) return

            const payload = {
              userDetails: {
				email                      : this.email,
              },
            }
		    this.$vs.loading();
			// PROCESO DE CREACION DE CUENTA 
            this.$store.dispatch('auth/recoverUserJWT', payload).then((response)=>{
                this.$vs.loading.close(); 
                this.mensaje      = response.data.mensaje;
                this.popupMensaje = true;
			})
	        .catch(error => { 
                this.$vs.loading.close(); 
                this.mensaje      = error;
                this.popupMensaje = true;
			});
        }
    },
    computed:{
        validateForm() {
            return !this.errors.any() && this.email != ''  ;
        }
    },
    created(){
        this.validatorOnline();
    }
}
</script>
